import cx from 'classnames';

import { toShipLevel } from '~/helpers/formatting';

import styles from './BattleTeamsList.scss';

import type { ReactNode } from 'react';
import type { IClanBattleTeam, IClanBattleTeamPlayer } from '~/types/declaration';

interface BattleTeamsListProps {
  isShow: boolean;
  userTeam: IClanBattleTeam;
  enemyTeam: IClanBattleTeam;
}

const BattleTeamsList = ({ isShow, userTeam, enemyTeam }: BattleTeamsListProps) => {
  const renderShip = (icons: IClanBattleTeamPlayer['ship']['icons'], survived = false) => {
    if (!icons) {
      return null;
    }

    const icon = survived ? icons.alive : icons.dead;
    return <img className={styles.shipImage} src={icon} alt="" />;
  };

  const renderTeam = (players: IClanBattleTeamPlayer[], isEnemy = false) => {
    const teamList = players.map((player, index) => {
      let shipName: string | undefined;
      let shipLevel: string | undefined;
      let shipIcon: ReactNode | undefined;

      if (player.ship) {
        shipName = player.ship.name;
        shipLevel = toShipLevel(player.ship.level);
        shipIcon = renderShip(player.ship.icons, player.survived);
      } else {
        shipName = shipLevel = shipIcon = '';
      }

      return (
        <div
          key={index}
          className={cx(styles.player, {
            [styles.isSurvived]: player.survived,
          })}
        >
          <div className={styles.nickname}>{player.nickname}</div>
          {shipIcon}
          <div>{shipLevel}</div>
          <div className={styles.shipName}>{shipName}</div>
        </div>
      );
    });

    return <div className={cx(styles.team, { [styles.enemyTeam]: isEnemy })}>{teamList}</div>;
  };

  return (
    <div className={cx(styles.container, { [styles.isShow]: isShow })}>
      {renderTeam(userTeam.players)}
      {renderTeam(enemyTeam.players, true)}
    </div>
  );
};

export default BattleTeamsList;
